/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does an A+ count higher than an A?`)
};

const es_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Una A+ cuenta más que una A?`)
};

const de_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zählt ein A+ mehr als ein A?`)
};

const nl_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telt een A+ zwaarder dan een A?`)
};

const fr_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un A+ compte-t-il plus qu'un A ?`)
};

const it_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una A+ vale più di una A?`)
};

const pt_br2_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um A+ vale mais do que um A?`)
};

const pt_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um A+ conta mais do que um A?`)
};

const ja_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A+はAより高くカウントされますか?`)
};

const zh_gpa_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A+ 的绩点会比 A 高吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_q4", locale)
	if (locale === "en") return en_gpa_faq_q4(inputs)
	if (locale === "es") return es_gpa_faq_q4(inputs)
	if (locale === "de") return de_gpa_faq_q4(inputs)
	if (locale === "nl") return nl_gpa_faq_q4(inputs)
	if (locale === "fr") return fr_gpa_faq_q4(inputs)
	if (locale === "it") return it_gpa_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_q4(inputs)
	if (locale === "pt") return pt_gpa_faq_q4(inputs)
	if (locale === "ja") return ja_gpa_faq_q4(inputs)
	return zh_gpa_faq_q4(inputs)
};